import DgoContainer from "@/components/DGOContainer/DGOContainer.vue";
import DgoRow from "@/components/DGORow/DGORow.vue";
import DgoCol from "@/components/DGOCol/DGOCol.vue";
import NntPopup from "@/components/NNTPopup/NNTPopup.vue";

export default {
    components: {
        NntPopup,
        DgoContainer,
        DgoRow,
        DgoCol,
    },
    data() {
        return {};
    },
}
